var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWait = function SvgWait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 6.398,
    fill: "#fff",
    rx: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 16,
    y: 6.4,
    fill: "#fff",
    fillOpacity: 0.32,
    rx: 1.6,
    transform: "rotate(90 16 6.4)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 14.789,
    y: 12.525,
    fill: "#fff",
    fillOpacity: 0.32,
    rx: 1.6,
    transform: "rotate(135 14.79 12.525)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 12.523,
    y: 1.212,
    fill: "#fff",
    fillOpacity: 0.32,
    rx: 1.6,
    transform: "rotate(45 12.523 1.212)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 6.398,
    y: 11.2,
    fill: "#fff",
    fillOpacity: 0.32,
    rx: 1.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 4.801,
    y: 6.4,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(90 4.8 6.4)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 6.867,
    y: 4.605,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(135 6.867 4.605)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 4.8,
    x: 4.605,
    y: 9.131,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(45 4.605 9.131)"
  })));
};
export default SvgWait;